import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { MailCheck, ArrowLeft } from "lucide-react";
import { useI18n } from "../lib/i18n";

export default function ForgotPasswordPage() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, base_url: window.location.origin });
    } catch {
      // We intentionally show the same confirmation regardless of outcome.
    }
    setLoading(false);
    setSent(true);
  };

  if (sent) {
    return (
      <div className="mx-auto flex max-w-md flex-col px-6 py-16 text-center" data-testid="forgot-sent">
        <span className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-[#4A7C59]/12 text-[#4A7C59]">
          <MailCheck size={26} />
        </span>
        <h1 className="mt-5 font-heading text-2xl font-semibold text-[#1A2024]">{t("forgot.sent_title")}</h1>
        <p className="mx-auto mt-3 max-w-sm font-body text-sm text-[#5C6873]">{t("forgot.sent_sub")}</p>
        <Link to="/login" className="mt-6 inline-flex items-center justify-center gap-1 font-body text-sm text-[#2E3A46] hover:underline" data-testid="forgot-back-link">
          <ArrowLeft size={14} /> {t("forgot.back_to_login")}
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto flex max-w-md flex-col px-6 py-16" data-testid="forgot-page">
      <h1 className="font-heading text-3xl font-semibold text-[#1A2024]">{t("forgot.title")}</h1>
      <p className="mt-2 font-body text-sm text-[#5C6873]">{t("forgot.sub")}</p>

      <form onSubmit={onSubmit} className="mt-8 space-y-5">
        <div>
          <Label htmlFor="email" className="font-body text-sm text-[#1A2024]">{t("auth.email")}</Label>
          <Input
            id="email"
            data-testid="forgot-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="mt-1.5 h-11 border-[#E2E8F0] bg-white"
          />
        </div>
        <Button type="submit" disabled={loading} data-testid="forgot-submit-btn" className="h-11 w-full bg-[#2E3A46] text-white hover:bg-[#1A2024]">
          {loading ? t("forgot.sending") : t("forgot.submit")}
        </Button>
      </form>

      <Link to="/login" className="mt-6 inline-flex items-center gap-1 font-body text-sm text-[#2E3A46] hover:underline" data-testid="forgot-back-link">
        <ArrowLeft size={14} /> {t("forgot.back_to_login")}
      </Link>
    </div>
  );
}
